import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// TODO: Add SEO props
const seo = {
  description: '',
};

const StyledFAQPage = styled(StyledInformationalPage)`
  .faq-field:not(:last-of-type) {
    margin-bottom: 3.75em;
  }

  .faq-field-question {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
  }

  .faq-field-answer {
    font-size: 1rem;
  }
`;

const title = 'Preguntas Frecuentes';

// tslint:disable:max-line-length
// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout seo={seo} locale='es-EM'>
    <HeadTitle title={title} />
    <StyledFAQPage>
      <div className='content'>
        <section>
          <h1>Preguntas Frecuentes</h1>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿Qué es WarnerBrosLatino.com?</h2>
            <div className='faq-field-answer'>
              <p>
                WarnerBrosLatino.com es un sitio único para todo lo relacionado con Warner Bros. - películas,
                televisión, entretenimiento en casa, juegos ¡y mucho más!
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              ¿Cómo puedo conseguir boletos para la grabación en vivo de un programa?
            </h2>
            <div className='faq-field-answer'>
              <p>
                Si estás interesado en ir a una grabación en vivo de tu serie favorita, visita el sitio{' '}
                <a href='http://www.tvtickets.com' target='_blank'>
                  www.tvtickets.com
                </a>
                . Ahí encontrarás toda la inormación que necesitas. Para obtener boletos para el show de Ellen
                Degeneres, visita{' '}
                <a href='http://send.ellentv.com/tickets/' target='_blank'>
                  http://send.ellentv.com/tickets/
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿Puedo asistir a la premiere de una película?</h2>
            <div className='faq-field-answer'>
              <p>
                A las premieres de las películas generalmente se puede acceder únicamente con invitaciones especiales,
                pero si estás registrado en WarnerBrosLatino.com o WarnerPass.com podrás recibir invitaciones en tu
                email si existen funciones en tu ciudad.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              ¿Cómo puedo adquirir entradas para el Tour de los Estudios de Warner Bros.?
            </h2>
            <div className='faq-field-answer'>
              <p>
                ¡Sí es posible visitar los Estudios de Warner Bros.! Para más información sobre la experiencia del tour,
                cómo planear tu visita y comprar entradas, consulta el sitio de{' '}
                <a href='http://www.wbstudiotour.com' target='_blank'>
                  Warner Bros. Studio Tour Hollywood
                </a>{' '}
                o{' '}
                <a href='http://www.wbstudiotour.co.uk' target='_blank'>
                  Warner Bros. Studio Tour London
                </a>{' '}
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿Cómo puedo registrarme para ver contenido exclusivo de WB Games?</h2>
            <div className='faq-field-answer'>
              <p>
                Inscríbete a <a href='https://www.wbplay.com/es#/'>WBPlay</a> para obtener acceso a contenido extra,
                participar en la comunidad de WB Games, desbloquear contenido interactivo espectacular y recibir
                noticias sobre WB Games.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿Dónde puedo solicitar apoyo filantrópico?</h2>
            <div className='faq-field-answer'>
              <p>
                Para más información sobre como dar en Warner Bros. y{' '}
                <a href='https://www.wbcitizenship.com/community/corporate-philanthropy/'>
                  nuestros programas filantrópicos corporativos
                </a>{' '}
                visita nuestro sitio <a href='http://www.wbcitizenship.com/'>Warner Bros. Citizenship</a>.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿Cómo puedo trabajar para Warner Bros.?</h2>
            <div className='faq-field-answer'>
              <p>
                Para ver la lista de todos los puestos disponibles en nuestra empresa, visita{' '}
                <a href='https://www.warnerbroscareers.com/'>Warner Bros. Careers</a>.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              Produje una película, serie de televisión o tengo un guión. ¿Cómo la puedo enviar a Warner Bros.?
            </h2>
            <div className='faq-field-answer'>
              <p>
                La política de Warner Bros. Entertainment, establecida por su departamento legal, prohibe considerar
                cualquier material de película, televisión u otro tipo de material de historia, salvo que sea enviado
                por un agente literario autorizado que sea firmante del Gremio de Escritores de América. Si estás
                interesado en obtener una lista de los agentes acreditados, llama al Sindicato de Guionistas de Estados
                Unidos al +1 323-951-4000 o manda un email por el sitio web{' '}
                <a href='http://www.wga.org/'>www.wga.org</a>.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              ¿A quién puedo contactar acerca de notas de prensa y consultas para los medios?
            </h2>
            <div className='faq-field-answer'>
              <p>
                Para consultas de prensa y medios, visita nuestro sitio de{' '}
                <a href='https://www.warnerbros.com/studio/press-releases/press-contacts-warnerbroscom-studio'>
                  Contactos de Prensa
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿A quién puedo contactar acerca de licencias de imágenes y clips?</h2>
            <div className='faq-field-answer'>
              <p>
                Por favor contacta a nuestro departamento de imágenes y clips por{' '}
                <a href='mailto:clipandstilldept@warnerbros.com'>clipandstilldept@warnerbros.com</a>.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>¿A quién puedo contactar acerca de licencia de productos?</h2>
            <div className='faq-field-answer'>
              <p>
                Por favor contacta nuestro departamento para licencias de productos para el consumidor por{' '}
                <a href='mailto:wbcpinquiries@warnerbros.com'>wbcpinquiries@warnerbros.com</a>.
              </p>
            </div>
          </div>
        </section>
      </div>
    </StyledFAQPage>
  </DefaultLayout>
);
